import type { EventBusPayload } from "@/modules/event-bus";

import { useTranslation } from "react-i18next";

import { ONE_MINUTE_IN_SECONDS } from "@/constants/Time";
import { isModelDeleteAsyncFailedNotificationPayload } from "@/entities/broadcast-notification";
import { useInvalidateNotifications } from "@/entities/notifications";
import { useAppNotification } from "@/modules/app-notification";
import { useAsyncActions } from "@/modules/async-actions";

export const useModelDeleteAsyncActionFailed = () => {
  const { notify } = useAppNotification();
  const { removeDeletingState, setFailedState } = useAsyncActions();
  const { invalidateNotifications } = useInvalidateNotifications();

  const { t } = useTranslation();

  const runAction = (payload: EventBusPayload) => {
    if (!isModelDeleteAsyncFailedNotificationPayload(payload)) return;

    notify.error({
      key: payload.id,
      title: t("notification:asyncDelete.description.failure"),
      duration: ONE_MINUTE_IN_SECONDS,
    });

    payload.models.forEach((model) => {
      removeDeletingState(model.type, model.id);
      setFailedState(model.type, model.id);
    });

    invalidateNotifications("*");
  };

  return { runAction };
};
